import { ActivatedRouteSnapshot, CanActivateChildFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { LocationRefService } from '../../share/services/location-ref.service';
import { Pages, toCommands } from '../../../constants/pages';

export const defaultRouting = (): CanActivateChildFn => {
  let isExecuted = false;

  return ({ queryParams }: ActivatedRouteSnapshot) => {
    const router = inject(Router);
    const location = inject(LocationRefService);
    const pathName = location.nativeLocation.pathname;
    let navigatePath: string[] = [];

    if (pathName.indexOf('/join') !== -1) {
      navigatePath = toCommands(Pages.offers);
    }

    if (pathName.indexOf('/account') !== -1) {
      navigatePath = toCommands(Pages.account);
    }

    if (pathName.indexOf('/quick-renew') !== -1) {
      navigatePath = toCommands(Pages.renew);
    }

    if (pathName.indexOf('/gift-membership') !== -1) {
      navigatePath = toCommands(Pages.giftOffers);
    }

    if (pathName.toLocaleLowerCase().indexOf('/mobileapprenewpaynow') !== -1) {
      navigatePath = ['mobile-renew'];
    }

    if (navigatePath.length && !isExecuted && !router.routerState.snapshot.url) {
      // check if should redirect
      // check if executed first time
      // check if app is empty to be able redirect user
      router.navigate(navigatePath, { queryParams });
      isExecuted = true;

      return false;
    } else {
      isExecuted = true;

      return true;
    }
  };
};

export default defaultRouting;
